/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Error_Shop_Tier_Name_DuplicateInputs */

const vi_error_shop_tier_name_duplicate = /** @type {(inputs: Error_Shop_Tier_Name_DuplicateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đã có hạng tên "${i?.name}".`)
};

/**

* @param {Error_Shop_Tier_Name_DuplicateInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_shop_tier_name_duplicate = /** @type {((inputs: Error_Shop_Tier_Name_DuplicateInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Shop_Tier_Name_DuplicateInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_shop_tier_name_duplicate(inputs)
});